import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getInventoryLocationData: {
    loading: false,
    error: null,
    data: null,
  },
  addInventoryLocationData: {
    loading: false,
    error: null,
    data: null,
  },
  deleteInventoryLocation: {
    loading: false,
    error: null,
    data: null,
  },
  editInventoryLocation: {
    loading: false,
    error: null,
    data: null,
  },
  selectedInventoryLocation: {
    loading: false,
    error: null,
    data: null,
  },
};

const InventoryLocationSlice = createSlice({
  name: "inventoryLocation",
  initialState,
  reducers: {
    getInventoryLocationDataStart: (state) => {
      state.getInventoryLocationData.loading = true;
      state.getInventoryLocationData.error = null;
      state.getInventoryLocationData.data = null;
    },
    getInventoryLocationDataSuccess: (state, action) => {
      state.getInventoryLocationData.loading = false;
      state.getInventoryLocationData.data = action.payload;
      state.getInventoryLocationData.error = null;
    },
    getInventoryLocationDataFailure: (state, action) => {
      state.getInventoryLocationData.loading = false;
      state.getInventoryLocationData.error = action.payload;
      state.getInventoryLocationData.data = null;
    },

    addInventoryLocationStart: (state) => {
      state.addInventoryLocationData.loading = true;
      state.addInventoryLocationData.error = null;
      state.addInventoryLocationData.data = null;
    },
    addInventoryLocationSuccess: (state, action) => {
      state.addInventoryLocationData.loading = false;
      state.addInventoryLocationData.data = action.payload;
      state.addInventoryLocationData.error = null;
    },
    addInventoryLocationFailure: (state, action) => {
      state.addInventoryLocationData.loading = false;
      state.addInventoryLocationData.error = action.payload;
      state.addInventoryLocationData.data = null;
    },
    addInventoryLocationResetForm: (state, action) => {
      state.addInventoryLocationData.loading = false;
      state.addInventoryLocationData.error = null;
      state.addInventoryLocationData.data = null;
    },

    deleteInventoryLocationStart: (state) => {
      state.deleteInventoryLocation.loading = true;
      state.deleteInventoryLocation.error = null;
      state.deleteInventoryLocation.data = null;
    },
    deleteInventoryLocationSuccess: (state, action) => {
      state.deleteInventoryLocation.loading = false;
      state.deleteInventoryLocation.data = action.payload;
      state.deleteInventoryLocation.error = null;
    },
    deleteInventoryLocationFailure: (state, action) => {
      state.deleteInventoryLocation.loading = false;
      state.deleteInventoryLocation.error = action.payload;
      state.deleteInventoryLocation.data = null;
    },
    deleteInventoryLocationResetForm: (state, action) => {
      state.deleteInventoryLocation.loading = false;
      state.deleteInventoryLocation.error = null;
      state.deleteInventoryLocation.data = null;
    },

    editInventoryLocationStart: (state) => {
      state.editInventoryLocation.loading = true;
      state.editInventoryLocation.error = null;
      state.editInventoryLocation.data = null;
    },
    editInventoryLocationSuccess: (state, action) => {
      state.editInventoryLocation.loading = false;
      state.editInventoryLocation.data = action.payload;
      state.editInventoryLocation.error = null;
    },
    editInventoryLocationFailure: (state, action) => {
      state.editInventoryLocation.loading = false;
      state.editInventoryLocation.error = action.payload;
      state.editInventoryLocation.data = null;
    },
    editInventoryLocationResetForm: (state, action) => {
      state.editInventoryLocation.loading = false;
      state.editInventoryLocation.error = null;
      state.editInventoryLocation.data = null;
    },

    selectedInventoryLocationStart: (state) => {
      state.selectedInventoryLocation.loading = true;
      state.selectedInventoryLocation.error = null;
      state.selectedInventoryLocation.data = null;
    },
    selectedInventoryLocationSuccess: (state, action) => {
      state.selectedInventoryLocation.loading = false;
      state.selectedInventoryLocation.data = action.payload;
      state.selectedInventoryLocation.error = null;
    },
    selectedInventoryLocationFailure: (state, action) => {
      state.selectedInventoryLocation.loading = false;
      state.selectedInventoryLocation.error = action.payload;
      state.selectedInventoryLocation.data = null;
    },
    selectedInventoryLocationResetForm: (state, action) => {
      state.selectedInventoryLocation.loading = false;
      state.selectedInventoryLocation.error = null;
      state.selectedInventoryLocation.data = null;
    },
  },
});

export const {
  getInventoryLocationDataStart,
  getInventoryLocationDataFailure,
  getInventoryLocationDataSuccess,

  addInventoryLocationStart,
  addInventoryLocationSuccess,
  addInventoryLocationFailure,
  editInventoryLocationStart,
  editInventoryLocationSuccess,
  editInventoryLocationFailure,
  editInventoryLocationResetForm,

  deleteInventoryLocationStart,
  deleteInventoryLocationSuccess,
  deleteInventoryLocationFailure,
  deleteInventoryLocationResetForm,

  selectedInventoryLocationStart,
  selectedInventoryLocationSuccess,
  selectedInventoryLocationFailure,
  selectedInventoryLocationResetForm,
} = InventoryLocationSlice.actions;

export default InventoryLocationSlice.reducer;
